type OffsetSide = 'top' | 'bottom';
interface SetBarOffsetArgs {
  id: string;
  height: number;
  side: OffsetSide;
}

interface BarOffsetStore {
  topOffsets: Map<string, number>;
  bottomOffsets: Map<string, number>;
  bodyPositionRefsCount: number;
}

declare global {
  var __ELFSIGHT_WIDGET_MODAL_BAR_OFFSET_STORE__: BarOffsetStore | undefined;
}

function getStore(): BarOffsetStore {
  if (!globalThis.__ELFSIGHT_WIDGET_MODAL_BAR_OFFSET_STORE__) {
    globalThis.__ELFSIGHT_WIDGET_MODAL_BAR_OFFSET_STORE__ = {
      topOffsets: new Map<string, number>(),
      bottomOffsets: new Map<string, number>(),
      bodyPositionRefsCount: 0
    };
  }

  return globalThis.__ELFSIGHT_WIDGET_MODAL_BAR_OFFSET_STORE__;
}

function getOffsetsTotal(offsets: Map<string, number>) {
  return [...offsets.values()].reduce((sum, current) => sum + current, 0);
}

function applyHtmlMargins() {
  const { topOffsets, bottomOffsets } = getStore();
  const html = document.documentElement;
  const topMargin = getOffsetsTotal(topOffsets);
  const bottomMargin = getOffsetsTotal(bottomOffsets);

  html.style.marginTop = topMargin > 0 ? `${topMargin}px` : '';
  html.style.marginBottom = bottomMargin > 0 ? `${bottomMargin}px` : '';
}

export function clearBarOffset(id: string) {
  const { topOffsets, bottomOffsets } = getStore();
  topOffsets.delete(id);
  bottomOffsets.delete(id);
}

export function setBarOffset({ id, height, side }: SetBarOffsetArgs) {
  clearBarOffset(id);

  if (height > 0) {
    const { topOffsets, bottomOffsets } = getStore();
    const offsets = side === 'bottom' ? bottomOffsets : topOffsets;
    offsets.set(id, height);
  }

  applyHtmlMargins();
}

export function releaseBarOffset(id: string) {
  clearBarOffset(id);
  applyHtmlMargins();
}

export function acquireBodyRelativePosition() {
  const store = getStore();
  store.bodyPositionRefsCount += 1;

  if (store.bodyPositionRefsCount === 1) {
    document.body.style.position = 'relative';
  }
}

export function releaseBodyRelativePosition() {
  const store = getStore();
  store.bodyPositionRefsCount = Math.max(0, store.bodyPositionRefsCount - 1);

  if (store.bodyPositionRefsCount === 0) {
    document.body.style.position = '';
  }
}
